export default {
  computed: {
    $allProductCodeTypes: function () {
      return this.$store.state.PromoCodeTypeStore.all_promo_code_types
    }
  }
}
